var _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBasket = function SvgBasket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.75 5.25a5.25 5.25 0 1 1 10.5 0v6h-1.5v-6a3.75 3.75 0 1 0-7.5 0v6h-1.5v-6Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.207 6h19.588l-.804 13.65C18.876 22.075 16.9 24 14.5 24h-9c-2.389 0-4.423-1.914-4.539-4.352L.207 6Zm1.586 1.5.667 12.076C2.536 21.213 3.91 22.5 5.5 22.5h9c1.577 0 2.916-1.275 2.993-2.924v-.01L18.205 7.5H1.793Z",
    fill: "#fff"
  })));
};
export default SvgBasket;